import { create } from "zustand";

export interface Keywords {
  main: string[];
  additional: string[];
  excluded: string[];
}

interface KeywordsState {
  keywords: Keywords;
  setKeywords: (value: Keywords) => void;
  clearKeywords: () => void;
}

export const useKeywordsStore = create<KeywordsState>((set) => ({
  keywords: { main: [], additional: [], excluded: [] },
  setKeywords: (value) => set({ keywords: value }),
  clearKeywords: () =>
    set({ keywords: { main: [], additional: [], excluded: [] } }),
}));
